import { Phone, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL_DISPLAY, EMAIL_HREF, LOGO_EMBLEM, ROSE_LIGHT_BL, ROSE_LIGHT_BR } from "@/data/services";

const CVR_NUMBER = "46752309";

const LinkBtn = ({ testid, onClick, children }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className="text-xs uppercase tracking-[0.15em] text-[color:var(--rs-muted)] transition-colors duration-300 hover:text-[color:var(--rs-gold)]"
  >
    {children}
  </button>
);

export const Footer = ({ theme }) => {
  const navigate = useNavigate();

  return (
    <footer id="kontakt" className="relative overflow-hidden border-t border-[color:var(--rs-border)] py-16">
      {theme === "light" && (
        <>
          <img src={ROSE_LIGHT_BL} alt="" aria-hidden="true" className="pointer-events-none absolute bottom-0 left-0 z-0 w-32 sm:w-44 lg:w-56" />
          <img src={ROSE_LIGHT_BR} alt="" aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 z-0 w-32 sm:w-44 lg:w-56" />
        </>
      )}
      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center px-6 text-center lg:px-8">
        <img src={LOGO_EMBLEM} alt="Royal Solutions" className="h-14 w-auto" />
        <p className="mt-3 font-heading text-xl tracking-[0.3em] text-[color:var(--rs-text)]">
          ROYAL <span className="text-[color:var(--rs-gold)]">SOLUTIONS</span>
        </p>
        <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-[color:var(--rs-gold)]">
          Professionel service • Eksklusive events
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-[color:var(--rs-muted)]">
          Din partner til fest, event og hverdag – professionelt personale og skræddersyede
          løsninger, samlet ét sted.
        </p>

        <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:gap-10">
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="inline-flex items-center gap-3 text-lg text-[color:var(--rs-text)] transition-colors duration-300 hover:text-[color:var(--rs-gold)]">
            <Phone size={18} className="text-[color:var(--rs-gold)]" /> {PHONE_DISPLAY}
          </a>
          <a href={`mailto:${EMAIL_HREF}`} data-testid="footer-email-link" className="inline-flex items-center gap-3 text-lg text-[color:var(--rs-text)] transition-colors duration-300 hover:text-[color:var(--rs-gold)]">
            <Mail size={18} className="text-[color:var(--rs-gold)]" /> {EMAIL_DISPLAY}
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          <LinkBtn testid="footer-terms" onClick={() => navigate("/handelsbetingelser")}>Handelsbetingelser</LinkBtn>
          <LinkBtn testid="footer-privacy" onClick={() => navigate("/privatlivspolitik")}>Privatlivspolitik</LinkBtn>
          <span className="text-xs uppercase tracking-[0.15em] text-[color:var(--rs-muted)]">CVR-nr.: {CVR_NUMBER}</span>
          <LinkBtn testid="footer-cookies" onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}>Cookieindstillinger</LinkBtn>
        </div>

        <div className="mt-10 w-full border-t border-[color:var(--rs-border)] pt-6 text-xs uppercase tracking-[0.3em] text-[color:var(--rs-muted)]">
          © {new Date().getFullYear()} Royal Solutions
        </div>
      </div>
    </footer>
  );
};
